import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import CustomerDatasourceLicence from './CustomerDatasourceLicence';
import mapCustomerDatasourceLicence from './mapCustomerDatasourceLicence';

export interface Result {
	items: CustomerDatasourceLicence[];
}

export default function findCustomerDatasourceLicences(client: ApiClient, customerId: string): Promise<Result> {
	const url = parseTemplate('customers/{customerId}/datasource-licences');
	return client
		.fetch(url.expand({ customerId }))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(mapCustomerDatasourceLicence),
		}));
}
